import { Overlay, VerticalContainer, useFormContext } from '@american-autonomy/ag-ui';

import Modal from 'components/Modal';
import MultiSelectBoundaryField from 'components/fields/MultiSelectBoundaryField';
import SelectPrimaryBoundaryField from 'components/fields/SelectPrimaryBoundaryField';

import useBoundarySelections from './hooks/useBoundarySelections';
import {
    BOUNDARIES_FIELD_NAME,
    PRIMARY_BOUNDARY_FIELD_NAME
} from './hooks/useBoundarySelections/constants';

import { TEST_ID } from './constants';
import type { FieldFormSchema, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FieldBoundaryFields: FunctionComponent<Props> = ({
    className = '',
    siteId,
    testId = TEST_ID
}) => {
    const { control } = useFormContext<FieldFormSchema>();
    const {
        handleBoundaryRemove,
        handleBoundaryToggle,
        handleModalClose,
        handleModalConfirm,
        handlePrimaryRemove,
        handlePrimarySelected,
        isModalOpen,
        modalConfig,
        primaryBoundary
    } = useBoundarySelections({ siteId });

    const excludedValues = primaryBoundary ? [primaryBoundary] : [];

    return (
        <VerticalContainer className={`${styles.fieldBoundaryFields} ${className}`} testId={testId}>
            <SelectPrimaryBoundaryField<FieldFormSchema>
                control={control}
                name={PRIMARY_BOUNDARY_FIELD_NAME}
                onChange={handlePrimarySelected}
                onRemove={handlePrimaryRemove}
                siteId={siteId}
            />

            <MultiSelectBoundaryField<FieldFormSchema>
                control={control}
                excludedValues={excludedValues}
                name={BOUNDARIES_FIELD_NAME}
                onRemove={handleBoundaryRemove}
                onToggle={handleBoundaryToggle}
                siteId={siteId}
            />

            {isModalOpen && modalConfig && (
                <Overlay className={styles.overlay}>
                    <Modal
                        confirmText={modalConfig.confirmText}
                        confirmVariant={modalConfig.confirmVariant}
                        onBack={handleModalClose}
                        onConfirm={handleModalConfirm}
                        subText={modalConfig.subText}
                        text={modalConfig.text}
                    />
                </Overlay>
            )}
        </VerticalContainer>
    );
};

export default FieldBoundaryFields;
